// Use this for Local Development
// export const WEBSITE_URL = "http://127.0.0.1:8000";    

// Production API URL (Backend Laravel)
// Alternative production URLs (uncomment as needed):
// export const WEBSITE_URL = "https://darkgray-magpie-119907.hostingersite.com/public";
export const WEBSITE_URL = "https://app.zaaapit.com/public";









// Comment out the above and Uncomment the below line before building the files for Production
//export const WEBSITE_URL = "https://" + window.location.hostname;

